import React from "react";
import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Logo } from "./assets/SvgImage";
import { useBreakpoints } from "./ResponsiveBreapoints";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const { IsXS, IsSM } = useBreakpoints();
  const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };
  return (
    <Grid container className={styles.headerContainer} justifyContent="center">
      <Grid size={{ xs: 12, sm: 11, md: 11, lg: 8, xl: 7 }}>
        <Grid container alignItems="center" justifyContent="center">
          <Grid>
            <div onClick={handleLogoClick} style={{ cursor: "pointer" }}>
              <Logo
                width={IsXS || IsSM ? "260px" : "400px"}
                height={IsXS || IsSM ? "100px" : "160px"}
                color="#ffffff"
              />
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Header;
